// import { getOrganization } from '@/api/organizations';
// import { Button } from '@/components/ui/button';
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
// } from '@/components/ui/card';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { Spinner } from '@/components/ui/spinner';
// import { Textarea } from '@/components/ui/textarea';
// import { formatAddress } from '@/helpers/formatAddress';
// import { Avatar, AvatarFallback, AvatarImage } from '@radix-ui/react-avatar';
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from '@/components/ui/select';
// import { useQuery } from '@tanstack/react-query';

// import { Save, Upload } from 'lucide-react';
// export default function OrganizationDetails() {
//   const { data: orgData, isLoading } = useQuery({
//     queryKey: ['organization'],
//     queryFn: getOrganization,
//   });

//   const organization = orgData;

//   if (isLoading) {
//     return <Spinner />;
//   }

//   return (
//     <div className="space-y-6">
//       <Card>
//         <CardHeader>
//           <CardTitle>Organization Details</CardTitle>
//           {/* <CardDescription>
//             Basic information about your organization
//           </CardDescription> */}
//         </CardHeader>
//         <CardContent className="space-y-4">
//           <div className="flex items-center gap-4">
//             {/* <Avatar className="h-16 w-16">
//               <AvatarImage src={'organization.logo' || '/placeholder.svg'} />
//               <AvatarFallback className="bg-blue-100 text-blue-700 text-lg font-bold">
//                 {organization?.name
//                   .split(' ')
//                   .map((n) => n[0])
//                   .join('')
//                   .slice(0, 2)}
//               </AvatarFallback>
//             </Avatar> */}
//             {/* <Button variant="outline" size="sm">
//               <Upload className="h-4 w-4 mr-2" />
//               Upload Logo
//             </Button> */}
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div className="space-y-2">
//               <Label htmlFor="org-name">Organization Name</Label>
//               <Input disabled id="org-name" defaultValue={organization?.name} />
//             </div>
//             <div className="space-y-2">
//               <Label htmlFor="org-domain">Domain</Label>
//               <Input
//                 disabled
//                 id="org-domain"
//                 defaultValue={organization?.domain}
//               />
//             </div>
//           </div>

//           <div className="space-y-2">
//             <Label htmlFor="org-description">Description</Label>
//             <Textarea
//               disabled
//               id="org-description"
//               placeholder="Brief description of your organization"
//               defaultValue="Leading utility company serving the metropolitan area with reliable power distribution and emergency response services."
//               className="resize-none"
//               rows={3}
//             />
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             {/* <div>
//               <Label htmlFor="org-phone">Phone</Label>
//               <Input id="org-phone" defaultValue={organization?.} />
//             </div> */}
//             <div className="space-y-2">
//               <Label htmlFor="org-email">Email</Label>
//               <Input
//                 disabled
//                 id="org-email"
//                 defaultValue="contact@citypower.com"
//               />
//             </div>
//           </div>

//           <div className="space-y-2">
//             <Label htmlFor="org-address">Address</Label>
//             <Textarea
//               id="org-address"
//               disabled
//               defaultValue={formatAddress(
//                 organization?.address1 || 'N/A',
//                 organization?.address2,
//                 organization?.city || 'N/A',
//                 organization?.state,
//                 organization?.country,
//                 organization?.zipcode,
//               )}
//               className="resize-none"
//               rows={2}
//             />
//           </div>
//         </CardContent>
//       </Card>

//       <Card>
//         <CardHeader>
//           <CardTitle>Regional Settings</CardTitle>
//           <CardDescription>Configure timezone and localization</CardDescription>
//         </CardHeader>
//         <CardContent className="space-y-4">
//           <div>
//             <Label htmlFor="timezone">Timezone</Label>
//             <Select disabled defaultValue={organization?.timezone}>
//               <SelectTrigger>
//                 <SelectValue />
//               </SelectTrigger>
//               <SelectContent>
//                 <SelectItem value="America/New_York">
//                   Eastern Time (ET)
//                 </SelectItem>
//                 <SelectItem value="America/Chicago">
//                   Central Time (CT)
//                 </SelectItem>
//                 <SelectItem value="America/Denver">
//                   Mountain Time (MT)
//                 </SelectItem>
//                 <SelectItem value="America/Los_Angeles">
//                   Pacific Time (PT)
//                 </SelectItem>
//                 <SelectItem value="America/Phoenix">
//                   Arizona Time (MST)
//                 </SelectItem>
//                 <SelectItem value="America/Anchorage">
//                   Alaska Time (AKST)
//                 </SelectItem>
//                 <SelectItem value="Pacific/Honolulu">
//                   Hawaii Time (HST)
//                 </SelectItem>
//                 <SelectItem value="Europe/London">London (GMT)</SelectItem>
//                 <SelectItem value="Europe/Paris">Paris (CET)</SelectItem>
//                 <SelectItem value="Asia/Tokyo">Tokyo (JST)</SelectItem>
//                 <SelectItem value="Australia/Sydney">Sydney (AEDT)</SelectItem>
//               </SelectContent>
//             </Select>
//             <p className="text-sm text-gray-500 mt-1">
//               This timezone will be used for all timestamps and scheduling
//               throughout the system.
//             </p>
//           </div>

//           <div className="pt-4">
//             <Button disabled>
//               <Save className="h-4 w-4 mr-2" />
//               Save Settings
//             </Button>
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }
//@ts-nocheck
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import { getOrganization } from '@/api/organizations';

import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Separator } from '@/components/ui/separator';
import { Building2, Globe, MapPin } from 'lucide-react';
import { SimpleForm } from '@/components/SimpleForm';

export const OrganizationDetails = () => {
  const { data: orgData, isLoading } = useQuery({
    queryKey: ['organization'],
    queryFn: getOrganization,
  });

  const methods = useForm({
    defaultValues: {
      name: '',
      domain: '',
      description: '',
      email: '',
      phone: '',
      address1: '',
      city: '',
      state: '',
      zipcode: '',
      timezone: '',
    },
  });

  useEffect(() => {
    if (orgData) {
      methods.reset(orgData);
    }
  }, [orgData, methods]);

  const onSubmit = (data: any) => {
    console.log('Submitting:', data);
    // Call API here
  };

  if (isLoading) {
    return <OrganizationSkeleton />;
  }

  return (
    <SimpleForm
      methods={methods}
      onSubmit={onSubmit}
      submitText="Save Changes"
      className="space-y-6"
    >
      <Card className="border-border shadow-sm">
        <CardHeader className="pb-1">
          <CardTitle>Organization Profile</CardTitle>
          <CardDescription>
            Manage your company's public information, branding, and regional
            settings.
          </CardDescription>
        </CardHeader>

        <Separator />

        <CardContent className="space-y-8 pt-2">
          <section className="space-y-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-8 w-8 rounded-lg bg-secondary/10 flex items-center justify-center text-secondary">
                <Building2 className="h-4 w-4" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground">
                  General Information
                </h3>
                {/* <p className="text-xs text-muted-foreground">
                  Basic identity details.
                </p> */}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pl-0 md:pl-2">
              <div className="space-y-2">
                <Label htmlFor="name">Organization Name</Label>
                <Input
                  id="name"
                  placeholder="e.g. City Power & Light"
                  {...methods.register('name')}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="domain">Domain</Label>
                <div className="flex">
                  {/* <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-input bg-muted text-muted-foreground text-sm">
                    https://
                  </span> */}
                  <Input
                    id="domain"
                    className="rounded-l-none"
                    placeholder="citypower.com"
                    {...methods.register('domain')}
                  />
                </div>
              </div>

              <div className="col-span-1 md:col-span-2 space-y-2">
                <Label htmlFor="description">Description</Label>
                <Textarea
                  id="description"
                  placeholder="Brief description of your organization..."
                  className="resize-none min-h-[80px]"
                  {...methods.register('description')}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="email">Contact Email</Label>
                <Input id="email" type="email" {...methods.register('email')} />
              </div>
              <div className="space-y-2">
                <Label htmlFor="phone">Phone Number</Label>
                <Input
                  id="phone"
                  type="tel"
                  placeholder="(555) 000-0000"
                  {...methods.register('phone')}
                />
              </div>
            </div>
          </section>

          <Separator />

          <section className="space-y-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-8 w-8 rounded-lg bg-secondary/10 flex items-center justify-center text-secondary">
                <MapPin className="h-4 w-4" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground">
                  Location & Regional
                </h3>
                <p className="text-xs text-muted-foreground">
                  Address and timezone settings.
                </p>
              </div>
            </div>

            <div className="grid gap-6 pl-0 md:pl-2">
              <div className="space-y-2">
                <Label htmlFor="address1">Street Address</Label>
                <Input
                  id="address1"
                  placeholder="123 Utility Blvd"
                  {...methods.register('address1')}
                />
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="col-span-2 space-y-2">
                  <Label htmlFor="city">City</Label>
                  <Input
                    id="city"
                    placeholder="Metropolis"
                    {...methods.register('city')}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="state">State</Label>
                  <Input
                    id="state"
                    placeholder="NY"
                    {...methods.register('state')}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="zipcode">Zip</Label>
                  <Input
                    id="zipcode"
                    placeholder="10001"
                    {...methods.register('zipcode')}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
                <div className="space-y-2">
                  <Label htmlFor="timezone" className="flex items-center gap-2">
                    <Globe className="h-3.5 w-3.5" /> Timezone
                  </Label>
                  <Select
                    defaultValue={orgData?.timezone || 'America/New_York'}
                    onValueChange={(val) => methods.setValue('timezone', val)}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select timezone" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="America/New_York">
                        Eastern Time (ET)
                      </SelectItem>
                      <SelectItem value="America/Chicago">
                        Central Time (CT)
                      </SelectItem>
                      <SelectItem value="America/Denver">
                        Mountain Time (MT)
                      </SelectItem>
                      <SelectItem value="America/Los_Angeles">
                        Pacific Time (PT)
                      </SelectItem>
                      <SelectItem value="Europe/London">
                        London (GMT)
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </div>
          </section>
        </CardContent>
      </Card>
    </SimpleForm>
  );
};

function OrganizationSkeleton() {
  return (
    <Card className="w-full">
      <CardHeader>
        <Skeleton className="h-8 w-48 mb-2" />
        <Skeleton className="h-4 w-64" />
      </CardHeader>
      <CardContent className="space-y-8">
        <div className="space-y-4">
          <Skeleton className="h-8 w-8 rounded-lg" />
          <div className="grid grid-cols-2 gap-6">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </div>
        </div>
        <div className="space-y-4">
          <Skeleton className="h-8 w-8 rounded-lg" />
          <Skeleton className="h-24 w-full" />
        </div>
      </CardContent>
    </Card>
  );
}
